import {getClientLeads, getSearchByStatus, updateClientLeadStatus} from "../../api/endpoints/lead";
import {getLeadStatuses} from "../../api/endpoints/clients";

export const state = {
    kanban: [],
    leadDate: null,
    leadStatuses: [],
    curLeadStatus: 1,
    total: 1,
}

export const getters = {
    getCheckedOrdersSum:state => {
        let leadByStatus = state.kanban.filter(item => item.order_checked)

        return leadByStatus.length;
    },
    total(state) {
        return state.total
    }
}

export const mutations = {
    SET_KANBAN_DATA(state, payload) {
        state.total = payload.clients.total;
        state.kanban = payload.clients.data;
        state.kanban.forEach( item => {item.order_checked = false});
        state.leadStatuses = payload.statuses;
    },
    CHANGE_KANBAN_STATUS(state, payload) {
        let from_kanban = state.kanban.filter(item => item.status.id == payload.from_status);
        let to_kanban = state.kanban.filter(item => item.status.id == payload.to_status);
        to_kanban[0].clients.data.splice(payload.to_index,0,from_kanban[0].clients.data[payload.from_index]);
        from_kanban[0].clients.data.splice(payload.from_index,1)

    },
    SET_LEAD_DATE(state, date) {
        state.leadDate = date;
    },
    UPDATE_LEAD_STATUS(state, status) {
        state.curLeadStatus = status;
    },
    UPDATE_LEADS_BY_STATUS(state, data) {
        state.kanban[data.lead_index] = data.data;
    }
}
export const actions = {
    fetchKanbanData({commit, state}, params) {
        return new Promise((resolve, reject) => {
            getClientLeads({...params, ...{date: state.leadDate, status_id: state.curLeadStatus}}).then(res => {
                commit('SET_KANBAN_DATA',res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    changeLeadStatus({state}, data) {
        return new Promise((resolve) => {
            let lead = state.kanban.filter(item => item.status.id == data.to_status);
            let leadId = lead[0].clients.data[data.to_index].id;
            updateClientLeadStatus({id: leadId, status_id: parseInt(data.to_status)}).then(res => {
                // commit('CHANGE_KANBAN_STATUS', data)
                resolve(res)
            })

        })
    },
    fetchLeadStatuses({commit}) {
        getLeadStatuses({count: true}).then(res => {
            commit('SET_LEAD_STATUSES', res.data.data);
        })
    },
    searchByStatus({commit, state}, data) {
        return new Promise(resolve => {
            getSearchByStatus({...data.params,...{date: state.leadDate}}).then(res => {
                commit('UPDATE_LEADS_BY_STATUS',{data: res.data.data, lead_index: data.lead_index});
                resolve(res);
            })
        })
    }
}
